import { useCallback } from "react";

import { OnEdit } from "components/EditableTable/EditableTable";
import { withNewValue } from "services/withNewValue";
import { convertToDurationAndAddToObject } from "services/convertToDurationAndAddToObject";

export function useHandleOKTimeOfDayField() {
	return useCallback(function handleOK<T>(
		row: T,
		newValue: number | undefined,
		rowKey: keyof T,
		onEdit: OnEdit<T>
	) {
		withNewValue(newValue, val => {
			const newData = convertToDurationAndAddToObject(row, val, rowKey);
			onEdit([{ old: row, new: newData }]);
		});
	},
	[]);
}
